const numberFormat = new Intl.NumberFormat();

function formatDurationSeconds(value) {
  const seconds = Number.isFinite(value) ? Math.max(0, Math.round(value)) : 0;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainder = String(seconds % 60).padStart(2, "0");
  return hours ? `${hours}:${String(minutes).padStart(2, "0")}:${remainder}` : `${minutes}:${remainder}`;
}

function formatPeakTime(value, watching) {
  if (!value) return "No peak yet";
  const time = new Date(value).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return Number.isFinite(watching) ? `at ${time} · peak watching ${watching}` : `at ${time}`;
}

// Labels say "browsers": unique counts key on a per-browser viewer id (localStorage), not IP addresses.
export default function SummaryCards({ analytics }) {
  const cards = [
    { label: "Page views", value: analytics.total_page_views, subLabel: "total visits to this page" },
    { label: "Unique visitors", value: analytics.unique_page_viewers, subLabel: "distinct browsers that opened the page" },
    { label: "Reached player", value: analytics.unique_player_viewers, subLabel: "browsers past password/countdown" },
    { label: "Peak concurrent", value: analytics.peak_concurrent, subLabel: formatPeakTime(analytics.peak_concurrent_at, analytics.peak_watching) },
    { label: "Watch views", value: analytics.total_watch_views, subLabel: "visits where the video played" },
    { label: "Unique watchers", value: analytics.unique_watch_viewers, subLabel: "distinct browsers that played" },
    { label: "Total watch time", value: formatDurationSeconds(analytics.watch_duration_seconds), subLabel: "summed across all viewers" },
    { label: "Median watch time", value: formatDurationSeconds(analytics.median_watch_duration_seconds), subLabel: "per visit that played" },
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <article key={card.label} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{card.label}</p>
          <p className="mt-3 font-mono text-3xl font-semibold text-slate-950">
            {typeof card.value === "number" ? numberFormat.format(card.value) : card.value ?? 0}
          </p>
          <p className="mt-2 text-xs text-slate-500">{card.subLabel}</p>
        </article>
      ))}
    </div>
  );
}
